import React from "react";
import "./robots-card.css";
import { Link } from "react-router-dom";
import { Badge, Space, Tag } from "antd";
import { useTranslation } from "react-i18next";

const getConnectingUserClientByRole = (robot, roleName) => {
  if (!robot || !robot?.connecting_user_clients) {
    return [];
  }
  const seenUserClients = new Set();
  return Object.entries(robot.connecting_user_clients)
    ?.filter((item) => {
      if (!item) {
        return false;
      }
      const [userClient, value] = item;
      if (!userClient || !value || !value.role) {
        return false;
      }
      if (value.role !== roleName) {
        return false;
      }
      if (seenUserClients.has(userClient)) {
        return false;
      }
      seenUserClients.add(userClient);
      return true;
    })
    .map((item) => {
      const [userClient, value] = item;
      return {
        user_client_id: userClient,
        state: value.state,
        role: value.role,
      };
    });
};

const RobotConnectionCardItem = (props) => {
  const { t } = useTranslation();
  const robot = props.ConnectionInfo;

  const monitorUsers = getConnectingUserClientByRole(robot, "monitor");
  const controlUsers = getConnectingUserClientByRole(robot, "controller");
  const robotStatus = robot.status;

  const shutdownRobotClick = props.shutdownRobotClick;

  const restartRobotClick = props.restartRobotClick;
  const settingRobotClick = props.settingRobotClick;

  const showDeveloperLink = props.ShowDeveloperLink;

  const [showOfflineRobots, setShowOfflineRobots] = React.useState(
    props?.ShowOfflineRobots
  );

  return (
    <div className="card shadow-sm">
      <Badge.Ribbon
        text={t(`robots.${robotStatus}`)}
        color={robotStatus == "offline" ? "black" : "blue"}
        placement="end"
      >
        <svg
          className="bd-placeholder-img card-img-top"
          width="100%"
          height="125"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          aria-label="Placeholder: Thumbnail"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
        >
          <title>{robot?.robot_id | ""}</title>
          <rect
            width="100%"
            height="100%"
            fill={robot.status == "offline" ? "#55595c" : "#558c5c"}
          ></rect>
          <image
            xlinkHref={
              robot.type == "gocart"
                ? "images/gocart.png"
                : robot.type == "spot"
                ? "images/spot.jpg"
                : robot.type == "syscon"
                ? "images/syscon.png"
                : robot.type == "tracer"
                ? "images/tracer.png"
                : robot.type == "demobot2"
                ? "images/demobot2.png"
                : "images/unknown_robot_type.png"
            }
            width="100%"
            height="100%"
            className={robot.status == "offline" ? "disabled-image" : ""}
          />
        </svg>
      </Badge.Ribbon>
      <div className="card-body">
        <h5 className="card-title">
          <b>
            {robot.id} {robot.status == "offline" && `(${t('robots.offline')})`}
          </b>
          <div>
            <Space direction="horizontal" size="middle">
              <span className="d-flex justify-content-between align-items-left">
                {t('robots.monitors')} ({monitorUsers.length}):
              </span>
              {monitorUsers &&
                monitorUsers.map(({ user_client_id, state, role }) => (
                  <Tag
                    key={user_client_id}
                    // className="d-flex align-items-center"
                    // color="blue" randomize color
                    color={
                      state == "connected"
                        ? "green"
                        : state == "connecting"
                        ? "orange"
                        : state == "disconnected"
                        ? "red"
                        : state == "closed"
                        ? "gray"
                        : "gray"
                    }
                  >
                    {user_client_id}/
                  </Tag>
                ))}
            </Space>
          </div>
          <div>
            <Space direction="horizontal" size="middle">
              <span className="d-flex justify-content-between align-items-left">
                {t('robots.controller')} ({controlUsers.length}):
              </span>
              {controlUsers &&
                controlUsers.map(({ user_client_id, state, role }) => (
                  <Tag
                    key={user_client_id}
                    // className="d-flex align-items-center"
                    // color="blue" randomize color
                    color={
                      state == "connected"
                        ? "green"
                        : state == "connecting"
                        ? "orange"
                        : state == "disconnected"
                        ? "red"
                        : state == "closed"
                        ? "gray"
                        : "gray"
                    }
                  >
                    {user_client_id}/
                  </Tag>
                ))}
            </Space>
          </div>
        </h5>
        <div className="d-flex justify-content-between align-items-center">
          <div className="btn-group">
            {robot.status != "offline" && (
              <Link
                to={
                  "/robots/" +
                  robot.id +
                  (robot.type ? "/" + robot.type : "/teleops")
                }
                className={
                  "btn btn-sm btn-outline-secondary" +
                  (robot.status == "offline" ? " disabled" : "")
                }
              >
                {t('robots.connect')}
              </Link>
            )}
            {robot.status != "offline" && (
              <Link
                to={
                  "/robot-camera/" +
                  robot.id +
                  "?show-status=true&local-mic=true&remote-mic=true&remote-cam=true"
                }
                className={
                  "btn btn-sm btn-outline-secondary" +
                  (robot.status == "offline" ? " disabled" : "")
                }
              >
                {t('robots.monitor')}
              </Link>
            )}
            <Link
              to={"/robots/setting/" + robot.id}
              className="btn btn-sm btn-outline-secondary"
            >
              {t('robots.setting')}
            </Link>

            {/* {robot.status != "offline" && (
              <Link
                type="button"
                className={
                  "btn btn-sm btn-outline-secondary" +
                  (robot.status == "offline" ? " disabled" : "")
                }
                onClick={() => restartRobotClick(robot)}
              >
                {t('robots.restart')}
              </Link>
            )} */}
            {/* {robot.status != "offline" && (
              <Link
                type="button"
                className={
                  "btn btn-sm btn-outline-secondary" +
                  (robot.status == "offline" ? " disabled" : "")
                }
                onClick={() => shutdownRobotClick(robot)}
              >
                {t('robots.shutdown')}
              </Link>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RobotConnectionCardItem;
